import React from "react";
import { Clock } from "lucide-react";
import { RESTAURANT } from "../data/menu";
import { useReveal } from "../hooks/useReveal";

export default function Hours() {
  const ref = useReveal();
  return (
    <section
      id="oeffnungszeiten"
      data-testid="hours-section"
      className="relative py-24 md:py-28 px-6 bg-ink-soft"
    >
      <div className="max-w-4xl mx-auto reveal" ref={ref}>
        <div className="text-center mb-12">
          <p className="text-gold tracking-[0.4em] text-xs uppercase mb-4">Wir freuen uns auf Sie</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white flex items-center justify-center gap-4">
            <Clock className="text-gold w-8 h-8 md:w-10 md:h-10" />
            <span className="italic text-gradient-gold">Öffnungszeiten</span>
          </h2>
          <div className="gold-divider w-24 mx-auto mt-6" />
        </div>

        <div className="glass-panel rounded-2xl p-8 md:p-12">
          <div className="space-y-3">
            {RESTAURANT.hours.map((h, i) => (
              <div
                key={i}
                data-testid={`hours-row-${i}`}
                className={`flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-6 py-3 border-b border-gold/15 last:border-b-0 ${
                  h.closed ? "opacity-70" : ""
                }`}
              >
                <span className="font-serif text-lg md:text-xl text-white">{h.days}</span>
                {h.closed ? (
                  <span className="text-gold italic">Ruhetag</span>
                ) : (
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-6 text-white/85">
                    <span className="font-mono tracking-wide">{h.lunch} Uhr</span>
                    <span className="hidden sm:block w-1 h-1 rounded-full bg-gold/50" />
                    <span className="font-mono tracking-wide">{h.dinner} Uhr</span>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-8 p-5 rounded-xl bg-gold/10 border border-gold/30 text-center">
            <p className="text-gold font-medium text-sm md:text-base">
              Mittwoch ist Ruhetag – wir bitten um Ihr Verständnis.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
